import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import Breadcrumbs from '../components/Breadcrumbs'
import Button from '../components/Button'
import { Link } from 'react-router-dom'

const Header_3 = ({ module, title, description, image, sectionClass, activePage = "", activeInnerPage = "", showInfo = false, sendTitle = true, sticker = false, stickerColor = "orange", staticDescription = false, directImage=false }) => {
    const breakLine = (text) => {
        return text.split("\n").map((line, index) => (
            <React.Fragment key={index}>
                {line}
                {index !== text.split("\n").length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <>
            <section className={`no_banner pt-10 ${sectionClass}`}>
                {activePage && <div className='page-breadcrumb pb-5'>
                    <Breadcrumbs activePage={activePage} buttonText={sendTitle ? title : ''} sectionClass={sectionClass} activeInnerPage={activeInnerPage} />
                </div>}

                <div className='container mb-4'>
                    <div className='row'>
                        <div className='col-lg-4 title-col'>
                            <h1 className='text-orange' lang="de">{breakLine(title)}</h1>
                        </div>
                        <div className='col-lg-8 content-col fw_strong_500'>
                            {description && !staticDescription && <BlocksRenderer content={description} />}
                            {staticDescription && <p>{description}</p>}

                            {showInfo && <div className='info_detail mt-4'>
                                <img src='images/dummy-square.png' className='dummy_icon' alt='Jörg Gaertner' />
                                <div className="infotext">
                                    <h4 className="fs_26 fw-600 text-darkgrey mb-0">Jörg Gaertner</h4>
                                    <small>( Leitung Fachstelle )</small>
                                    <div className='Torsten_kontakt'>
                                        <Link to='mailto: JorgGaertner@bgzurlinden.ch'>
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="20" cy="20" r="19.5" stroke="inherit" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M29.9987 14.5305L23.0731 20.3358L29.9987 26.1411V14.5305ZM29.6527 27.045C29.4597 27.2249 29.2018 27.3359 28.9207 27.3359H10.4101C10.1299 27.3359 9.8729 27.2259 9.68085 27.0478L16.9758 20.9328L18.09 21.8673C18.5289 22.2348 19.1031 22.4175 19.6746 22.4147C20.2452 22.4119 20.8204 22.2254 21.262 21.8542L22.3614 20.9328L29.6527 27.045ZM9.33203 26.1459L16.2643 20.3359L9.33203 14.5258V26.1459ZM9.68088 13.6241C9.87292 13.445 10.1299 13.3359 10.4101 13.3359H28.9207C29.2027 13.3359 29.4606 13.4469 29.6527 13.6269L22.0758 19.9787L22.0656 19.9871L20.6796 21.1491C20.405 21.3794 20.0394 21.4951 19.672 21.4969C19.3056 21.4988 18.9428 21.3869 18.6738 21.1621L17.2729 19.988L17.2608 19.9777L9.68088 13.6241Z" fill="inherit" />
                                            </svg> JorgGaertner@bgzurlinden.ch
                                        </Link>
                                    </div>
                                </div>
                            </div>}

                            {module?.Komponente && <Button component={module?.Komponente} pdf={module?.PDF} buttons={module?.Button} />}
                        </div>
                    </div>
                </div>

                {module?.Bild_oder_Video === "Video" ? (
                    <video
                        src={`https://backend.bgzurlinden.ch${module?.Video?.url}`}
                        className="header-video position-static"
                        autoPlay
                        loop
                        muted
                        playsInline
                        webkit-playsinline="true"
                        preload="auto"
                        poster={`https://backend.bgzurlinden.ch${module?.Videominiatur?.url}`}
                        style={{ maxHeight: '700px', objectFit: 'cover' }}
                    >
                    </video>
                ) : (
                    // <img src={`https://backend.bgzurlinden.ch${image?.url}`} className='w-100' alt='#' />
                    // <img src={`https://backend.bgzurlinden.ch${image?.url}`} style={{ maxHeight: '700px', objectFit: 'cover' }} className='w-100 pt-4' alt='#' />
                    <img src={!directImage ? `https://backend.bgzurlinden.ch${image?.url}` : image} style={{ maxHeight: '700px', objectFit: 'cover' }} className='w-100 pt-4' alt='#' />
                )}
            </section>
            {sticker && <section className='mb-5'>
                <div className="container position-relative">
                    <div class="termin-btn">
                        <Link to={'/reparaturmeldung'}>
                            <div class={`rotating-booking ${stickerColor === "blue" ? "blue-sticker" : "orange-sticker"}`}>
                                <img src={stickerColor === "orange" ? "https://backend.bgzurlinden.ch/uploads/reparaturmeldung_icon_b1b44a1d2a.svg" : "https://backend.bgzurlinden.ch/uploads/reparaturmeldung_icon_blue_6c741e7edd.svg"} alt="#" />
                            </div>
                            {/* <img src="/images/new-zahlen-icon-2.svg" class="termin_center_icon" /> */}
                        </Link>
                    </div>
                </div>
            </section>}
        </>

    )
}

export default Header_3